import { useState } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { Box, Center, Text } from "@chakra-ui/react";
import { callCertificationApi } from "./api";
import AlertModal from "components/AlertModal";
import { ResStatus } from "lib/api/enum";
import withAuth from "lib/hook/withAuth";
import usePathNavigate from "lib/hook/usePathNavigate";

const Certification = () => {
    const { pathNavigate, backNavigate } = usePathNavigate();
    const location = useLocation();
    const searchQuery = queryString.parse(location.search);

    const channelName = localStorage.getItem("channel");
    const [activeAlert, setActiveAlert] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState("");

    const certApi = async (channel: string, accountCert: string) => {
        try {
            const result = await callCertificationApi({
                channel: channelName!,
                account_cert: accountCert,
            });
            console.log(result);

            if (result.status === ResStatus.RES_SUCCESS) {
                backNavigate();
                if (searchQuery.page) {
                    pathNavigate(`${searchQuery.page}`, {
                        replace: true,
                    });
                }
            } else if (result.status === ResStatus.RES_UNAUTHORIZED) {
                pathNavigate("/*", {
                    state: { session: "true" },
                    replace: true,
                });
            } else {
                setActiveAlert(true);
                setErrorMsg(result.result_message);
            }
        } catch (error) {
            setActiveAlert(true);
        }
        return;
    };

    /* 본인인증 후 콜백함수 */
    const callback = (response: any) => {
        console.log("callback : ", response, response.success);
        // error_code        :         null
        // error_msg        :         null
        // imp_uid        :         "imp_987966661590"
        // success        :         true
        if (response.success) {
            console.log("success : ", channelName, response.imp_uid);
            certApi(channelName!, response.imp_uid);
        } else {
            setActiveAlert(true);
            setErrorMsg(response.error_msg);
        }
    };

    function onClickCertification(e: any) {
        e.preventDefault();

        const userCode = "imp32970589"; // 가맹점 식별 코드
        const merchantUid = `mint_${new Date().getTime()}`;
        const company = "민트하우스"; // 회사명
        const carrier = ""; // 인증단계에서 선택

        /* 결제 데이터 */
        const data = {
            merchant_uid: merchantUid,
            company: company,
            carrier: carrier,
            name: "",
            phone: "",
            min_age: "",
        };

        const { IMP } = window;
        IMP.init(userCode);
        IMP.certification(data, callback);
    }

    const callbackAlert = () => {
        setActiveAlert(false);
        setErrorMsg("");
    };

    return (
        <Box mx="20px">
            <Center my={"18px"} fontSize="1.25rem" fontWeight={"semibold"}>
                주문/조회 인증
            </Center>
            <Text fontSize={"1rem"} fontWeight="semibold" mb="0.375rem">
                전화번호 인증
            </Text>
            <Text
                fontSize={"0.75rem"}
                fontWeight="semibold"
                color="#bdbdbd"
                mb="0.938rem"
            >
                안전하고 원활한 서비스 제공을 위해 인증을 진행해 주세요.
            </Text>

            <Box
                bgColor="#fff"
                maxW={"768px"}
                minW={"320px"}
                w="100%"
                h="3.125rem"
                border={"1px"}
            >
                <Center
                    w="100%"
                    h={"100%"}
                    fontSize={"0.975rem"}
                    fontWeight="semibold"
                    bg={"black"}
                    color={"#fff"}
                    onClick={onClickCertification}
                >
                    인증하기
                </Center>
            </Box>
            <AlertModal
                isOpen={activeAlert}
                errorMsg={errorMsg}
                callbackCompleted={callbackAlert}
            />
        </Box>
    );
};

export default withAuth(Certification);
